import { useState } from 'react'

import { InstalledSoftwareService, type InstalledSoftwareTrackingType } from './InstalledSoftwareService'

export const useAllowInstalledTracking = () => {
  const [allowTracking, setAllowTracking] = useState<InstalledSoftwareTrackingType | undefined>(() => {
    return InstalledSoftwareService.getAllowInstalledTracking()
  })

  const setAllowInstalledTracking = (value: InstalledSoftwareTrackingType) => {
    InstalledSoftwareService.setAllowInstalledTracking(value)
    setAllowTracking(value)
  }

  return [allowTracking, setAllowInstalledTracking] as const
}
